import { Text, Icon } from '@msc-b2c/shared-components';
import styles from '../stateroomdetails.module.scss';
import { MiscellaneousItemI, PassengerI } from '@msc-b2c/interfaces/interfaces';
import { getPassengersInfoByItem } from '../../utils/stateroomGenericUtils';

interface Props {
  miscellaneousItems: MiscellaneousItemI[];
  passengers: PassengerI[];
  title: string;
  label: string;
  icon: string;
}

const Miscellaneous = ({ miscellaneousItems, passengers, title, icon, label }: Props) => {
  const getPassengerNames = (item: MiscellaneousItemI) =>
    getPassengersInfoByItem(item, passengers).map((p) => `${p.name} ${p.surname}`);

  return miscellaneousItems.length > 0 ? (
    <div className={styles.miscellaneousContainer}>
      <Text
        text={title}
        styleOption={styles.miscellaneousTitle}
      />
      <div className={styles.miscellaneousWrapper}>
        {miscellaneousItems.map((item) => (
          <div
            className={styles.miscellaneousItem}
            key={item.code}
          >
            <div className={styles.miscellaneousItemContent}>
              <Icon icon={icon} />
              <div className={styles.miscellaneousItemName}>
                <Text text={`${item.description}:`} />
              </div>
              <Text text={getPassengerNames(item).join(', ')} />
            </div>
            <div className={styles.miscellaneousItemLabel}>
              <Text text={label} />
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default Miscellaneous;
